import React from 'react';

import { SvgIcon } from '../../../common/SvgIcon';

const Burger = ({ iconName }) => <SvgIcon name={iconName} />;

export default Burger;
